let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cxAqh")).then(() => parcelRequire('gbtcZ'));